export default __webpack_public_path__ + "static/media/482.dc6ef4dc.gif";